module.exports = __webpack_public_path__ + "static/demogorgon-d8e67066d85fb5cce81395f5f276b1eb.png";